import { logoutUserFX } from '../store/user/effects';

export const logout = async (removeCookie: (name: 'web_epak', options?: any) => void) => {
  logoutUserFX();
  removeCookie('web_epak');
};
